module.exports = __webpack_public_path__ + "static/media/Usual-Regular.ad6e3b04.ttf";